import React from 'react';
import '../../styles/sections.css';
import '../../styles/overview.css';

const Overview = () => {
  return (
          <section className="overview-section">
        <div className="section-header">
          <h2>OVERVIEW</h2>
          <div className="underline"></div>
        </div>
        <div className="overview-content">
        <p>
          Notify is a full-featured music streaming platform developed with ASP.NET and hosted on Microsoft Azure. 
          It empowers users to create secure accounts, browse a wide selection of music, and engage with content through features like song 
          liking and playlist creation. Users can curate, edit, and manage their personal playlists, revisit their favorited songs, and update 
          account details through an intuitive interface.
        </p>
        <p>
          Beyond streaming, Notify integrates a dedicated merchandise store where fans can browse and purchase products from their favorite 
          bands and artists. The platform also includes a support contact system for submitting feedback or reaching out for assistance. 
          Built with YouTube API integration and backed by a MySQL database, Notify offers a seamless and scalable web experience that blends 
          media interaction, personalization, and ecommerce.
        </p>
      </div>
    </section>
  );
};

export default Overview;
